import { Component, ViewChild } from '@angular/core';
import { DxBoxModule, DxScrollViewComponent, DxScrollViewModule, DxToolbarModule } from 'devextreme-angular';
import { TopupMerchantWalletComponent } from "../topup-merchant-wallet/topup-merchant-wallet.component";
import { TopupMerchantAccountComponent } from '../topup-merchant-account/topup-merchant-account.component';
import { LoadNewCardsComponent } from "../load-new-cards/load-new-cards.component";
import { AllocateCardsToMerchantComponent } from "../allocate-cards-to-merchant/allocate-cards-to-merchant.component";
import { QuickActionCardModule } from "../../../components/library/quick-action-card/quick-action-card.component";

@Component({
  standalone: true,
  imports: [DxBoxModule, DxToolbarModule, TopupMerchantWalletComponent, TopupMerchantAccountComponent, LoadNewCardsComponent, AllocateCardsToMerchantComponent, DxScrollViewModule, QuickActionCardModule],
  selector: 'app-quick-actions',
  templateUrl: './quick-actions.component.html',
  styleUrl: './quick-actions.component.scss'
})
export class QuickActionsComponent {
  isContentScrolled = false;
  routedData : number = 0;
  TopUpBalanceUpdate : number = 0

  @ViewChild(AllocateCardsToMerchantComponent) allocateCardsToMerchant!: AllocateCardsToMerchantComponent;
  @ViewChild(TopupMerchantWalletComponent) topupMerchantWalletComponent!: TopupMerchantWalletComponent;

  onNotify(data:number){
    this.routedData = data;
    this.allocateCardsToMerchant.handleCardStockUpdate(data);
  }

  onMerchantBalanceUpdate(data:number){
    this.TopUpBalanceUpdate = data
    this.topupMerchantWalletComponent.handleMerchantsBalanceUpdate(data);
  }

  scroll({reachedTop = false}) {
    this.isContentScrolled = !reachedTop;
  }
}
